import {Box, Button} from "@mui/material";
import {ArrowBackIosNew} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";
import {recipeAPI} from "../../../services/RecipeServices";
import {IRecipe} from "../../../models/Recipe/IRecipe";
import {getAllItemsV2, getAllProductTypesForRecipes} from "../dataManager";
import CreateRecipe from "./createRecipe/CreateRecipe";
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
import {ContentSkeleton} from '../../common/loading/ContentSkeleton';
import {DTO_STATE} from '@mybake/ui/common/dictionary';
import {recipeGuidRequest, recipePartComparisonSnapshot, recipePartGuidRequest} from '../shared/recipeFormHelpers';
import {fillingAPI} from '../../../services/FillingServices';

export const RecipeCreatePage = () => {
    const navigate = useNavigate();
    const {t} = useAppTranslation();
    const handleCreateMode = () => {
        navigate("..", {relative: "path"});
    }

    const {
        productTypes,
        isLoadingProductTypes,
        getProductTypesError,
        isSuccessProductTypes
    } = getAllProductTypesForRecipes();
    const {items, getAllItemsError, getAllItemsIsLoading, getAllItemsIsSuccess} = getAllItemsV2();
    const {data: fillings, isLoading: fillingsLoading} = fillingAPI.useGetFillingsV2AllLightQuery();

    const [createRecipe] = recipeAPI.useCreateRecipeV2Mutation();
    const [createRecipePart] = recipeAPI.useCreateRecipePartV2Mutation();
    const [attachRecipePart] = recipeAPI.useAttachRecipePartV2Mutation();
    const [updateRecipePart] = recipeAPI.useUpdateRecipePartV2Mutation();
    const handleCreateRecipe = async (formData: IRecipe) => {
        try {
            const libraryParts = (formData.parts ?? []).filter(part => part.clientOrigin === 'library' && part.state !== DTO_STATE.DTO_DELETED);
            const newParts = (formData.parts ?? []).filter(part => part.clientOrigin !== 'library' && part.state !== DTO_STATE.DTO_DELETED);
            const created = await createRecipe(recipeGuidRequest(formData)).unwrap();
            for (let sortOrder = 0; sortOrder < newParts.length; sortOrder += 1) {
                const createdPart = await createRecipePart(recipePartGuidRequest(newParts[sortOrder])).unwrap();
                await attachRecipePart({recipeId: created.id, partId: createdPart.id, isMainPart: Boolean(newParts[sortOrder].isMainPart), sortOrder}).unwrap();
            }
            for (let offset = 0; offset < libraryParts.length; offset += 1) {
                const part = libraryParts[offset];
                const partChanged = JSON.stringify(recipePartComparisonSnapshot(part)) !== part.clientOriginalSnapshot;
                if (partChanged) await updateRecipePart({id: String(part.id), body: recipePartGuidRequest(part)}).unwrap();
                await attachRecipePart({recipeId: created.id, partId: String(part.id), isMainPart: Boolean(part.isMainPart), sortOrder: newParts.length + offset}).unwrap();
            }
            handleCreateMode();
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    return <Box sx={{width: '100%'}}>
        <Button variant="outlined" startIcon={<ArrowBackIosNew/>}
                onClick={() => navigate("..", {relative: "path"})}>
            {t('recipes:back_to_recipes')}
        </Button>
        {(isLoadingProductTypes || getAllItemsIsLoading || fillingsLoading) ? <ContentSkeleton variant="form"/> : <CreateRecipe key={'isCreateRecipeMode'} items={items}
                      fillings={fillings}
                      productTypes={productTypes}
                      onSubmit={handleCreateRecipe}/>} 
    </Box>
}
